import {
  ENGLISH_LOCALE_IDENTIFIER,
  GERMAN_LOCALE_IDENTIFIER,
} from 'constants/i18n';
import lifestyleDE from 'public/static/about-us/lifestyle-de.png';
import lifestyleEN from 'public/static/about-us/lifestyle-en.png';
import oneAccountDE from 'public/static/about-us/oneaccount-de.jpg';
import oneAccountEN from 'public/static/about-us/oneaccount-en.jpg';
import transparentAdviceDE from 'public/static/about-us/transparent-advice-de.jpg';
import transparentAdviceEN from 'public/static/about-us/transparent-advice-en.jpg';
import vincentAndRob from 'public/static/about-us/Vincent-and-Rob.png';

const images = {
  transparentadvice: {
    [ENGLISH_LOCALE_IDENTIFIER]: transparentAdviceEN,
    [GERMAN_LOCALE_IDENTIFIER]: transparentAdviceDE,
  },
  lifestyle: {
    [ENGLISH_LOCALE_IDENTIFIER]: lifestyleEN,
    [GERMAN_LOCALE_IDENTIFIER]: lifestyleDE,
  },
  oneaccount: {
    [ENGLISH_LOCALE_IDENTIFIER]: oneAccountEN,
    [GERMAN_LOCALE_IDENTIFIER]: oneAccountDE,
  },
  history: {
    [ENGLISH_LOCALE_IDENTIFIER]: vincentAndRob,
    [GERMAN_LOCALE_IDENTIFIER]: vincentAndRob,
  },
};

export default images;
